import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: '编程学习平台【环森编程】' }
  },

  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta: { title: '关于我们 - 环森编程' }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { title: '登录 - 环森编程' }
  }
  ,
  {
    path: '/study',
    name: 'Study',
    component: () => import('../views/Study.vue'),
    meta: { title: '在线学习 - 环森编程' }
  },
  {
    path: '/statistic',
    name: 'Statistic',
    component: () => import('../views/Statistic.vue'),
    meta: { title: '学习统计 - 环森编程' }
  },

  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/admin/Index.vue'),
    meta: { title: '管理后台 - 环森编程' }
  },
  {
    path: '/admin/chapterMenu',
    name: 'chapterMenu',
    component: () => import('../views/admin/ChapterMenu.vue'),
    meta: { title: '章节管理 - 环森编程' }
  },
  {
    path: '/admin/chapterContentEdit',
    name: 'chapterContentEdit',
    component: () => import('../views/admin/ChapterContentEdit.vue'),
    meta: { title: '编辑章节 - 环森编程' }
  }
  ,
  {
    path: '/admin/batchCorrect',
    name: 'BatchCorrect',
    component: () => import('../views/admin/BatchCorrect.vue'),
    meta: { title: '批量批改 - 环森编程' }
  },
  {
    path: '/admin/classQuizReport',
    name: 'ClassQuizReport',
    component: () => import('../views/admin/ClassQuizReport.vue'),
    meta: { title: '班级报告 - 环森编程' }
  },
  {
    path: '/admin/statisticsClass',
    name: 'StatisticsClass',
    component: () => import('../views/admin/StatisticsClass.vue'),
    meta: { title: '班级统计 - 环森编程' }
  },
  {
    path: '/admin/statisticsStu',
    name: 'StatisticsStu',
    component: () => import('../views/admin/StatisticsStu.vue'),
    meta: { title: '学员统计 - 环森编程' }
  },
  {
    path: '/admin/statisticsStuPeriod',
    name: 'StatisticsStuPeriod',
    component: () => import('../views/admin/StatisticsStuPeriod.vue'),
    meta: { title: '学员阶段统计 - 环森编程' }
  },
  {

    path: '/room',
    name: 'Room',
    component: () => import('../views/Room.vue'),
    meta: { title: '学习室 - 环森编程' }
  },
  {

    path: '/roomStatistics',
    name: 'RoomStatistics',
    component: () => import('../views/RoomStatistics.vue'),
    meta: { title: '学习室统计 - 环森编程' }
  },
  {
    path: '/admin/recomputeScore',
    name: 'RecomputeScore',
    component: () => import('@/views/admin/RecomputeScore.vue'),
    meta: { title: '重新计分 - 环森编程' }
  },

  {
    path: '/admin/editQuiz',
    name: 'EditQuiz',
    component: () => import('@/views/admin/EditQuiz.vue'),
    meta: { title: '编辑题目 - 环森编程' }
  },

  {
    path: '/admin/section',
    name: 'Section',
    component: () => import('@/views/admin/Section.vue'),
    meta: { title: '小节管理 - 环森编程' }
  },

  {
    path: '/admin/addCourse',
    name: 'AddCourse',
    component: () => import('@/views/admin/AddCourse.vue'),
    meta: { title: '添加课程 - 环森编程' }
  }
  ,
  {
    path: '/admin/manageCourse',
    name: 'ManageCourse',
    component: () => import('@/views/admin/ManageCourse.vue'),
    meta: { title: '课程管理 - 环森编程' }
  }
  ,
  {
    path: '/admin/addClass',
    name: 'AddClass',
    component: () => import('@/views/admin/AddClass.vue'),
    meta: { title: '添加班级 - 环森编程' }
  }
  ,
  {
    path: '/admin/manageClass',
    name: 'ManageClass',
    component: () => import('@/views/admin/ManageClass.vue'),
    meta: { title: '班级管理 - 环森编程' }
  }
  ,
  {
    path: '/admin/importToClass',
    name: 'ImportToClass',
    component: () => import('@/views/admin/ImportToClass.vue'),
    meta: { title: '导入班级 - 环森编程' }
  }
  ,
  {
    path: '/admin/manageClassStudent',
    name: 'ManageClassStudent',
    component: () => import('@/views/admin/ManageClassStudent.vue'),
    meta: { title: '学员管理 - 环森编程' }
  },
  {
    path: '/admin/searchStudent',
    name: 'SearchStudent',
    component: () => import('@/views/admin/SearchStudent.vue'),
    meta: { title: '搜索学员 - 环森编程' }
  }
  ,
  {
    path: '/admin/correct',
    name: 'Correct',
    component: () => import('@/views/admin/Correct.vue'),
    meta: { title: '批改 - 环森编程' }
  },
  {
    path: '/my',
    name: 'My',
    component: () => import('@/views/My.vue'),
    meta: { title: '我的账号 - 环森编程' }
  }
  ,
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue'),
    meta: { title: '注册 - 环森编程' }
  }
  ,
  {
    path: '/admin/classCalendar',
    name: 'ClassCalendar',
    component: () => import('@/views/admin/ClassCalendar.vue'),
    meta: { title: '课程日历 - 环森编程' }
  },
  {
    path: '/admin/userLoginHistory',
    name: 'UserLoginHistory',
    component: () => import('@/views/admin/UserLoginHistory.vue'),
    meta: { title: '登录记录 - 环森编程' }
  },
  {
    path: '/admin/chapterQuizList',
    name: 'ChapterQuizList',
    component: () => import('@/views/admin/ChapterQuizList.vue'),
    meta: { title: '章节题目 - 环森编程' }
  },
  {
    path: '/admin/manageKeywords',
    name: 'ManageKeywords',
    component: () => import('@/views/admin/ManageKeywords.vue'),
    meta: { title: '字典管理 - 环森编程' }
  },
  {
    path: '/admin/purchaseManage',
    name: 'PurchaseManage',
    component: () => import('@/views/admin/PurchaseManage.vue'),
    meta: { title: '购买管理 - 环森编程' }
  },
  {
    path: '/pay',
    name: 'Pay',
    component: () => import('@/views/Pay.vue'),
    meta: { title: '付费 - 环森编程' }
  },
  {
    path: '/game',
    name: 'GameHome',
    component: () => import('../views/GameHome.vue'),
    meta: { title: '环森游戏 - 手游折扣平台' }
  },
  {
    path: '/game/search',
    name: 'GameSearch',
    component: () => import('../views/GameSearch.vue'),
    meta: { title: '找游戏 - 环森游戏' }
  },
  {
    path: '/game/detail',
    name: 'GameDetail',
    component: () => import('../views/GameDetail.vue'),
    meta: { title: '游戏详情 - 环森游戏' }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
